/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

import courseraCVectorBackgroundImage from 'images/degree-home/help-tip-vector.svg';

const styles = {
  card: (theme: Theme) => css`
    display: flex;
    padding: ${theme.spacing(32, 32, 16)};
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: ${theme.spacing(8)};
    background: #f5f7f8;
    box-sizing: border-box;
    min-width: 225px;
    background-image: url(${courseraCVectorBackgroundImage});
    background-repeat: no-repeat;
    background-position: top right;
    background-size: contain;

    ${theme.breakpoints.down('xs')} {
      min-width: 100%;
      width: 100%;
      padding: ${theme.spacing(24, 24, 16)};
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  `,
};

const HelpTipCard: React.FC = ({ children }) => <div css={styles.card}>{children}</div>;

export default HelpTipCard;
